import React from 'react'
import _ from 'lodash';

function DXFormFileUploader(props) {
  const {
    pid,
    question,
    valueState,
    setFormValueState
  } = props;

  const id = `${pid}.${question.id}`;

  // for viewer (read only)
  const fileInfo = _.get(valueState, id);

  const filesChanged = (e) => {

    console.log('event: ', e);
    const files = e.target.files;
    console.log('files = ', files);

    setFormValueState(id, files);
  }
  return (
    <div>
      {
        setFormValueState
          ? <input type='file' onChange={filesChanged} multiple />
          : fileInfo && fileInfo.map(item =>
            <li>
              <a href={item.url} download={item.filename}>
                {item.filename}({parseInt(item.size / 1024)} kb)
              </a>
              {
                item.type === 'image/png' || item.type === 'image/jpeg'
                  ? <img src={item.url} style={{ maxWidth: '50%' }} />
                  : null
              }
            </li>)
      }

    </div >
  )
}

export default DXFormFileUploader
